const Homepage = props => {
  return <div>HOMEPAGE</div>
}

export default Homepage
